export enum WeightUnit {
  kg = 'kg',
  lb = 'lb',
}
